/**
 * 过滤器
 */

export default {
    // 时间转换
    formatTime : function (timestamp) {
        if (!timestamp) {
            return ''
        }
        var times = new Date(timestamp);
        var nowTime = new Date(Date.now());
        var sizeTime = (nowTime.getTime() - times.getTime()) / 1000;

        // 大于24小时，小于30天
        if ( 3600 * 24 < sizeTime && sizeTime < 3600 * 24 * 30) {
            return parseInt(sizeTime / (3600 * 24)) + '天前';
        } else if (sizeTime <= 3600 * 24) { // 小于24小时
            //大于等于1小时    
            if (sizeTime >= 3600) {
                return parseInt(sizeTime / 3600) + '小时前';
                //大于一分钟
            } else if (sizeTime > 60) {
                return parseInt(sizeTime / 60) + '分钟前';
                //小于等于一分钟
            } else {
                return '刚刚';
            }
        } else {
            var toTen = function (num) {
                return num < 10 ? '0' + num : num;
            }
            var year = times.getFullYear();
            var month = toTen(times.getMonth() + 1);
            var date = toTen(times.getDate());
            var minute = toTen(times.getMinutes());
            var hour = toTen(times.getHours());
            var nowYear = nowTime.getFullYear();
            //不同年份
            // if (year !== nowYear) {
            //     return year + '-' + month + '-' + date + ' ' + hour + ':' + minute;
            //     //相同年份
            // } else {
            //     return month + '-' + date + ' ' + hour + ':' + minute;
            // }
            return year + '-' + month + '-' + date + ' ' + hour + ':' + minute;
        }
    },
    formatPublishTime(timestamp) {
        if (!timestamp) {
            return ''
        }
        var times = new Date(timestamp);
        var toTen = function (num) {
            return num < 10 ? '0' + num : num;
        }
        var year = times.getFullYear();
        var month = toTen(times.getMonth() + 1);
        var date = toTen(times.getDate());
        var minute = toTen(times.getMinutes());
        var hour = toTen(times.getHours());
        return year + '-' + month + '-' + date + ' ' + hour + ':' + minute;
        
    },
    //个位数转为十位数
    toTen: function (num) {
        return num < 10 ? '0' + num : num;
    },
    // 来源
    sourceReset: function (source) {
        return source || 'TY'
    },
    linkFilter(item) {
        return this.formatTime(item);
    },
    textOverflow(text) {
        if(text && text.length > 6) {
            return text.substr(0, 6) + '...'
        }
        return text
    },
    newsKind(item) {
        if(item.isSubjectEntrance) {
            return '专题'
        }
        if(item.extKind == 2) {
            return '活动'
        }
        return ''
    },
    resetNum: function (value) {
        if (!value || value < 0) {
            return 0;
        }
        var value = parseInt(value);
        return value >= 100000000 ? parseFloat((parseInt(value * 10 / 100000000) / 10).toFixed(1)) + '亿' : value >= 10000 ? parseFloat((parseInt(value * 10 / 10000) / 10).toFixed(1)) + '万' : value;
    },
    videoDuration(time) {
        if (!time) {
            return '00:00';
        }
        var time = parseInt(time);
        return time >= 60 ? Math.floor(time / 60) < 10 ? '0' + Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : (time < 10 ? '00:0' + time : '00:' + time);
    }
}